import { all, fork, put, call, select, takeLatest } from 'redux-saga/effects';
import { delay } from '../constants/Values';
import * as sosActions from '../actions/Sos';
import * as sosApi from '../api/Sos';
import { showErrorNotification } from '../actions/App';
import {
  START_SOS_SIGNAL_TIMER,
  CHECK_PASSWORD,
  SEND_SOS_SIGNAL,
  SAVE_NEW_TIMER_COUNT_VALUE,
  GET_ACTIVE_SIGNALS,
} from '../constants/ActionTypes';

const getTimerCount = state => state.sos.timerCount;
const getTimerStatus = state => state.sos.isTimerStarted;
const getCoordinates = state => state.sos.coords;

function* startSosTimer() {
  const currentTimerCount = yield select(getTimerCount);
  const isTimerStarted = yield select(getTimerStatus);
  while (currentTimerCount !== 0 && isTimerStarted) {
    yield delay(1000);
    yield put(sosActions.saveNewTimerValue({ timerCount: currentTimerCount - 1 }));
  }
  if (isTimerStarted) {
    yield put(sosActions.sendSosSignal());
  }
}

function* setSosSignal() {
  const coordinates = yield select(getCoordinates);
  try {
    yield call(sosApi.postSosRequest, coordinates);
    yield put(sosActions.sosSignalSuccess());
  } catch (error) {
    if (error && error.status === 403) {
      yield put(sosActions.sosActionForbidden(error.messages));
    } else {
      yield delay(1000);
      yield put(sosActions.sendSosSignal());
    }
  }
}

function* setPasswordCheck({ payload }) {
  const userPassword = payload.password;
  if (userPassword) {
    try {
      yield call(sosApi.verifyPassword, userPassword);
      yield put(sosActions.sendSignalAbort());
    } catch {
      yield put(sosActions.checkPasswordError({ isPasswordCorrect: false }));
    }
  }
}

function* getActiveSignals() {
  try {
    yield call(sosApi.getOpenedAlarmsCount);
    yield put(sosActions.getActiveSignalsSuccess(true));
  } catch (error) {
    if (error.errors) {
      yield put(showErrorNotification(error.message));
    } else {
      yield put(sosActions.getActiveSignalsSuccess(false));
    }
  }
}

export function* startSosTimerSaga() {
  yield takeLatest([START_SOS_SIGNAL_TIMER, SAVE_NEW_TIMER_COUNT_VALUE], startSosTimer);
}
export function* setSosSignalSaga() {
  yield takeLatest(SEND_SOS_SIGNAL, setSosSignal);
}
export function* setPasswordCheckSaga() {
  yield takeLatest(CHECK_PASSWORD, setPasswordCheck);
}

export function* getActiveSignalsSaga() {
  yield takeLatest(GET_ACTIVE_SIGNALS, getActiveSignals);
}

export default function* rootSaga() {
  yield all([
    fork(startSosTimerSaga),
    fork(setSosSignalSaga),
    fork(setPasswordCheckSaga),
    fork(getActiveSignalsSaga),
  ]);
}
